<script setup>
import HelpButton from "./partials/HelpButton.vue";
import TrafficFilter from "@/components/reporting/partials/TrafficFilter.vue";
import StatsRow from "@/components/reporting/partials/StatsRow.vue";
import WebsiteVisitors from "@/components/reporting/partials/WebsiteVisitors.vue";
import ClicksAndImpressions from "./partials/ClicksAndImpressions.vue";
import TopLocations from "@/components/reporting/partials/TopLocations.vue";
import TopSources from "@/components/reporting/partials/TopSources.vue";
import TopDevices from "@/components/reporting/partials/TopDevices.vue";
import {computed, onMounted, ref} from "vue";
import {scrollToComponent} from "@/composables/useScroll";

const clicksAndImpressions = ref(null);
const topLocations = ref(null);
const topDevices = ref(null);
const topSources = ref(null);

const query = new URLSearchParams(location.search);
const topLocationsActiveTab = computed(() => {
  return query.get('activeTab') === 'city' ? 'city' : 'country';
});

const topSourcesActiveTab = computed(() => {
  return query.get('activeTab') === 'referrers' ? 'referrers' : 'traffic';
});

onMounted(async () => {
  const activeTab = query.get('activeTab');

  if (activeTab === 'clicks') {
    await scrollToComponent(clicksAndImpressions);
  }

  if ((activeTab === 'city' || activeTab === 'country')) {
    await scrollToComponent(topLocations);
  }

  if ((activeTab === 'devices')) {
    await scrollToComponent(topDevices);
  }

  if (activeTab === 'referrers' || activeTab === 'traffic') {
    await scrollToComponent(topSources);
  }
});
</script>

<template>
  <div class="tw-m-auto tw-max-w-default-container">
    <div class="tw-flex tw-flex-col tw-gap-8">
      <div class="tw-flex tw-justify-between tw-items-center">
        <div class="tw-flex tw-space-x-8 tw-items-center">
          <h1 class="tw-text-4.5xl tw-text-font-primary tw-font-bold tw-font-sans">
            Your Traffic Statistics
          </h1>
        </div>

        <HelpButton />
      </div>

      <TrafficFilter />

      <div class="tw-bg-white tw-rounded tw-p-8 tw-grid tw-grid-cols-12 tw-gap-8">
        <StatsRow class="tw-col-span-12" />

        <WebsiteVisitors class="tw-col-span-12" />

        <ClicksAndImpressions
          ref="clicksAndImpressions"
          class="tw-col-span-12"
        />

        <TopLocations
          ref="topLocations"
          :initial-active-tab="topLocationsActiveTab"
          class="tw-col-span-6 tw-h-full"
        />

        <TopSources
          ref="topSources"
          :initial-active-tab="topSourcesActiveTab"
          class="tw-col-span-6 tw-h-full"
        />

        <TopDevices
          ref="topDevices"
          class="tw-col-span-12"
        />
      </div>
    </div>
  </div>
</template>
